import { useRef, useMemo } from 'react';

// This mimicks a constructor
const useOnce = <T>(callback: () => T) => {
  const ref = useRef<() => T>(callback);
  return useMemo(() => ref.current(), [ref]);
};

export default useOnce;
